import React from "react";
import { VideoBlock } from "types/cms";
import Header from "../../Header";
import * as Styled from "./styled";

const getEmbedUrl = (url: string) => {
  const baseUrl = url.split("?")[0];

  if (url.indexOf("vimeo") >= 0) {
    return baseUrl;
  }

  return url;
};

const Video: React.FC<VideoBlock> = ({
  isHero,
  isReverse,
  data: { eyebrow, heading, body, textSize, url },
}) => {
  const embedUrl = getEmbedUrl(url);

  return (
    <Styled.Wrapper>
      <Header
        eyebrow={eyebrow}
        heading={heading}
        body={body}
        isCentered
        isHero={isHero}
        textSize={textSize}
        isLight={isReverse}
      />

      <Styled.VideoWrapper>
        <iframe src={embedUrl} />
      </Styled.VideoWrapper>
    </Styled.Wrapper>
  );
};

export default Video;
